import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { PseService } from '@core/callbacks/services/pse.service';
import { TransactionService } from '@shared/services/transaction.service';
import { catchError, map } from 'rxjs';

@Component({
    selector: 'app-pse',
    templateUrl: './pse.component.html',
    styleUrls: ['./pse.component.css'],
    standalone: false
})

export class PseComponent {

  private token: string = '';

  constructor(
    private _pseService: PseService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _transactionService: TransactionService
  ) { }

  ngOnInit(): void {
    this._route.queryParams.pipe(
      map(params => {
        this.token = params['token']
      })
    ).subscribe();
    this.getTransactState(this.token);
  }

  getTransactState(token: string): void {
    this._pseService.pseCallback(token).pipe(
      catchError(error => {
        console.log(error);
        throw error;
      })
    ).subscribe(
      response => {
        this._transactionService.setTransactionSummary(response);
        this._router.navigate(['/', 'summary']);
      }
    );


  }
}
